import * as React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Box, SxProps, Typography } from '@mui/material';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 24,
  borderRadius: 15,
  width: '100%',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.mode === 'light' ? '#eaeafe' : '#1B0F3399',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.main : '#8F8F8F',
  },
}));

interface Props {
  value: number;
  sx?: SxProps;
  progressBarSx?: SxProps;
}

export default function CustomizedProgressBars({ value, sx, progressBarSx }: Props) {
  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{ flexGrow: 1, position: 'relative', width: '40%', ...sx }}
    >
      <Typography
        position={'absolute'}
        zIndex={999}
        sx={{ color: (theme) => theme.palette.background.primary, fontSize: 14, top: 2 }}
      >
        {value}%
      </Typography>
      <BorderLinearProgress variant="determinate" value={value} sx={progressBarSx} />
    </Box>
  );
}
